import Title from "../../../components/title/Title";

const ContactTitle = () => {
  return (
    <>
      <Title title="문의하기" />
    </>
  );
};
export default ContactTitle;
